var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-question"
  }, [_c('h2', [_vm.progressStep > 2 ? _c('span', [_vm._v(_vm._s(_vm.groupName))]) : _vm._e(), _vm._v(_vm._s(_vm.mainText) + " ")]), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.tt(_vm.subText))
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }